"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthenticationGatekeeper = void 0;
const react_1 = __importDefault(require("react"));
const Login_1 = __importDefault(require("../Login"));
const use_query_1 = __importDefault(require("../@common/hooks/network/use-query"));
const use_auth_strategy_factory_1 = require("../@internal/hooks/use-auth-strategy-factory");
const LwtGetUser_1 = __importDefault(require("../LwtGetUser"));
const DefaultLoadingComponent = () => react_1.default.createElement(react_1.default.Fragment, null, "Loading...");
const AuthenticationGatekeeper = (_a) => {
    var { Loading, UnauthenticatedApp, onAuthenticated, onError, options } = _a, props = __rest(_a, ["Loading", "UnauthenticatedApp", "onAuthenticated", "onError", "options"]);
    const { authValue, authenticate, loginUrl } = (0, use_auth_strategy_factory_1.useAuthStrategyFactory)();
    const { loading, data, err, onDoneValue: onAuthenticatedCallbackValue } = (0, use_query_1.default)(authenticate(authValue, props.config), {
        shouldRun: !!authValue,
        onDone: onAuthenticated,
        onError: err => onError === null || onError === void 0 ? void 0 : onError({ err, loginRedirect: Login_1.default })
    });
    const authenticated = !err && authValue && data;
    const isConsumerHandlingAuthenticationError = !authenticated && onError;
    const ConsumerDefinedUnauthenticatedApp = !authenticated && UnauthenticatedApp;
    const ConsumerDefinedUnauthorizedComponent = onAuthenticatedCallbackValue === null || onAuthenticatedCallbackValue === void 0 ? void 0 : onAuthenticatedCallbackValue.Component;
    const LoadingIndicator = Loading !== null && Loading !== void 0 ? Loading : DefaultLoadingComponent;
    const requiresRedirect = !authenticated ||
        ((onAuthenticatedCallbackValue === null || onAuthenticatedCallbackValue === void 0 ? void 0 : onAuthenticatedCallbackValue.authorized) === false && !ConsumerDefinedUnauthorizedComponent);
    if (loading)
        return LoadingIndicator;
    if (isConsumerHandlingAuthenticationError)
        return props.children;
    if (ConsumerDefinedUnauthenticatedApp)
        return UnauthenticatedApp;
    if (ConsumerDefinedUnauthorizedComponent)
        return ConsumerDefinedUnauthorizedComponent;
    if (requiresRedirect)
        return (0, Login_1.default)(loginUrl);
    return (react_1.default.createElement(LwtGetUser_1.default, { options: options, Loading: Loading, fallbackUser: data }, props.children));
};
exports.AuthenticationGatekeeper = AuthenticationGatekeeper;
exports.default = exports.AuthenticationGatekeeper;
